module.exports = __webpack_public_path__ + "static/fonts/Mont-Regular.adcc201.eot";